import React, { Fragment } from "react";

export const About = () => {
  return (
    <Fragment>
      <h1>About this app</h1>
      <p>App to search Github Users</p>
      <p>Version : 1.0.1</p>
    </Fragment>
  );
};
export default About;
